import styled from 'styled-components';

import media from 'chime-ui/system/media';

import { StickySubmitButtonWrapper } from 'styles/StickySubmitButtonWrapper';
import { ChecklistDisclaimerText } from 'styles/styleMixins';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
  padding: 1.5rem 0;
  align-items: center;
`;

export const Title = styled.h1`
  padding: 0;
  margin: 0;
  width: 100%;
  font-size: 24px;
`;

export const CenteredStickySubmitButtonWrapper = styled(
  StickySubmitButtonWrapper
)`
  ${media.tablet`
    margin-top:0.5rem;
  `}
`;

export const SpacedChecklistDisclaimerText = styled(ChecklistDisclaimerText)`
  margin-bottom: 10rem;
`;
